import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

import { PlusLg } from "react-bootstrap-icons";
import "./index.scss";
import { useTranslation } from "react-i18next";
import AppButton from "../AppButton";

export default function ModalForm({
  dialogContentChild,
  onCloseFunction = () => {},
  onCancelFunction = () => {},
  submitFunction = () => {},
  isOpened = false,
  dialogTitle,
  applyTitle = "",
  cancelText = "",
  disabled = false,
  loading = false,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={isOpened}
          onHide={onCloseFunction}>
          <Modal.Header closeButton>
            <Modal.Title>{dialogTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{dialogContentChild}</Modal.Body>
          <Modal.Footer>
            <AppButton
              loading={loading}
              children={t("ANNULER")}
              className="secondary"
              onClick={(e) => {
                onCancelFunction(e);
              }}
            />
            {applyTitle ? (
              <AppButton
                children={applyTitle}
                classNames="save_btn text-nowarp py-2 px-4"
                onClick={(e) => {
                  submitFunction(e);
                }}
              />
            ) : (
              <></>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
